import { fetchWithDelay } from "./fetch";
const url = "/mycvdata.json";

const fetchData = () => fetchWithDelay(url);

export const dataAPI = {
  fetchData
};
